export const setPage = (page) => {
  return {
    type: 'SETPAGE',
    payload: page,
  }
}
